import { createRoute, redirect } from '@tanstack/react-router'
import { rootRoute } from './__root'
import { Landing } from '@/pages/landing'
import { resolveLandingRoute } from '@/lib/landing'

interface LoginSearchParams {
  form?: 'login' | 'signup'
  /**
   * Password reset code delivered via email link, formatted as `<uid>@<token>`.
   * When present, the landing page renders the reset-password form instead of
   * the login/register view. TanStack Router's validateSearch is a strict
   * allowlist — this field must be returned there or it will be silently dropped.
   */
  code?: string
}

export const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  validateSearch: (search: Record<string, unknown>): LoginSearchParams => {
    return {
      form: search.form === 'login' || search.form === 'signup' ? search.form : undefined,
      // Must be explicitly returned — TanStack Router silently drops any field not present here.
      code: typeof search.code === 'string' ? search.code : undefined,
    }
  },
  beforeLoad: ({ context }) => {
    // If already authenticated, redirect to feed (or, with the Dashboard-
    // default-landing flag on, to /dashboard — see src/lib/landing.ts)
    if (context.isAuthenticated) {
      throw redirect({ to: resolveLandingRoute(context.isAuthenticated, '/feed') })
    }
  },
  component: Landing,
})
